import ColorfulEmpty from './colorful-empty';
export default ColorfulEmpty;
